import { ApiFunctionType, httpPost } from 'src/utils/http';
import { AccountOrganizerRecovery, PaymentIdRequestType } from 'src/models/Account/Organizer';
import {
  PaymentRecoveryCompleteResponseType,
  PaymentRecoveryResponseType,
  PayPalPaymentRecoveryResponseType,
} from 'src/models/Account/Organizer/paymentRecovery';

const getPath = (path: string) => `/account/organizer/PaymentRecoveryDialog/${path}`;

export const apiLoadPaymentRecoveryDialogModel: ApiFunctionType<PaymentIdRequestType, PaymentRecoveryResponseType> = (
  data
) => httpPost(getPath('LoadPaymentRecoveryDialogModel'), data);

export const apiLoadPayPalPaymentRecoveryDialogModel: ApiFunctionType<
  PaymentIdRequestType,
  PayPalPaymentRecoveryResponseType
> = (data) => httpPost(getPath('LoadPayPalPaymentRecoveryDialogModel'), data);

export const apiStartRecovering: ApiFunctionType<PaymentIdRequestType, AccountOrganizerRecovery> = (data) =>
  httpPost(getPath('StartRecovering'), data);

export const apiCompleteRecovering: ApiFunctionType<PaymentIdRequestType, PaymentRecoveryCompleteResponseType> = (
  data
) => httpPost(getPath('CompleteRecovering'), data);
